import { Tooltip } from "antd"
import { InfoCircleOutlined } from "@ant-design/icons"
import { getUserCookies } from "../../Cookies"
import { jwtDecode } from "jwt-decode"
import { translations } from "../../Translation/staticTranslation"

/**
 * @param {string} status — approved | pending | rejected
 * @param {string|null|undefined} effectiveHighest — from effectiveHighestRole(profile, jwt); profile market admins resolve to SUPERADMIN
 * @param {string|null|undefined} market_role — JWT market_role
 */
export const getStoreColumns = (status, effectiveHighest, market_role) => {
  const token = getUserCookies()?.token
  const decoded = token ? jwtDecode(token) : null
  const resolvedEffective = effectiveHighest ?? decoded?.highest_role
  const resolvedMarketRole = market_role ?? decoded?.market_role

  const lang = localStorage.getItem("language") || "ar"
  const tableText = translations[lang]?.StorePage?.storeTableCol
  const storeText = translations[lang]?.StorePage

  let columns = []

  if (status === "approved") {
    columns = [
      {
        label: tableText?.store_name,
        dataKey: lang === "ar" ? "store_name_arabic" : "store_name",
      },
      {
        label: tableText?.store_type,
        dataKey: lang === "ar" ? "provider_arabic" : "provider",
      },
      { label: tableText?.no_of_products, dataKey: "product_count" },
      { label: tableText?.status, dataKey: "active_status" },
    ]
  } else if (status === "pending") {
    columns = [
      {
        label: tableText?.store_name,
        dataKey: lang === "ar" ? "store_name_arabic" : "store_name",
      },
      {
        label: tableText?.store_type,
        dataKey: lang === "ar" ? "provider_arabic" : "provider",
      },
      {
        label: (
          <>
            <span className={`${lang === "ar" ? "ml-5" : "mr-5"}`}>
              {tableText?.status}
            </span>
            <Tooltip title={storeText?.store_pending_tooltip}>
              <InfoCircleOutlined />
            </Tooltip>
          </>
        ),
        dataKey: "request_status",
      },
    ]
  } else {
    columns = [
      {
        label: tableText?.store_name,
        dataKey: lang === "ar" ? "store_name_arabic" : "store_name",
      },
      {
        label: tableText?.store_type,
        dataKey: lang === "ar" ? "provider_arabic" : "provider",
      },
      {
        label: (
          <>
            <span className={`${lang === "ar" ? "ml-5" : "mr-5"}`}>
              {tableText?.status}
            </span>
            <Tooltip title={storeText?.store_rejected_tooltip}>
              <InfoCircleOutlined />
            </Tooltip>
          </>
        ),
        dataKey: "request_status",
      },
    ]
  }

  // Platform / profile market admin or JWT market viewer: show merchant column
  if (
    resolvedEffective === "SUPERADMIN" ||
    resolvedMarketRole === "2" ||
    resolvedMarketRole === "3"
  ) {
    columns.splice(1, 0, {
      label: tableText?.merchant_name,
      dataKey: lang === "ar" ? "business_name_arabic" : "business_name",
    })
  }

  return columns
}
